import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import usePageMeta from '../hooks/usePageMeta';

// All verified No-Belly on-ground activation photography, shown as a single unified gallery.
const EVENT_PHOTOS = [
  '/events/holi1.jpg',
  '/events/harley1.jpg',
  '/events/harley4.jpg',
  '/events/harley2.jpg',
  '/events/holi2.jpg',
  '/events/harley3.jpg',
];

// Event names only — no venue names per current brand guidance.
const EVENT_NAMES = [
  'Holi Festival Activation',
  'Harley Owners Group Meet',
  'Pickleball Tournament',
];

const Events = () => {
  usePageMeta({
    title: 'Events | No-Belly Bier — Brand in the Wild',
    description: 'Recent No-Belly on-ground activations — festivals, rider meets and sports weekends across Gurgaon.',
    path: '/events',
  });
  return (
  <main className="nb-page nb-page-events" data-testid="page-events">
    <section className="nb-page-hero">
      <div className="nb-page-hero-inner">
        <p className="nb-eyebrow">EVENTS</p>
        <h1 className="nb-display-md">BRAND IN THE WILD.</h1>
        <p className="nb-page-lede">
          No-Belly shows up where our community shows up — festivals, sports, rides and rooftops.
        </p>
      </div>
    </section>

    <section className="nb-events-unified" data-testid="events-unified">
      <div className="nb-events-unified-grid">
        {EVENT_PHOTOS.map((src, i) => (
          <div key={src} className="nb-events-unified-tile" data-testid={`events-photo-${i}`}>
            <img src={src} alt={`No-Belly on-ground activation ${i + 1}`} loading="lazy" />
          </div>
        ))}
      </div>

      <ul className="nb-events-namelist" data-testid="events-namelist-page">
        {EVENT_NAMES.map(name => <li key={name}>{name}</li>)}
      </ul>
    </section>

    <section className="nb-page-cta" data-testid="events-cta">
      <h2 className="nb-display-sm">POURING AT YOUR EVENT?</h2>
      <p className="nb-copy">Festivals, tournaments, launches — we love a good excuse to pour.</p>
      <Link to="/horeca" className="nb-cta-primary nb-cta-lg" data-testid="events-cta-trade">
        Partner With Us<ArrowRight size={18} />
      </Link>
    </section>
  </main>
  );
};

export default Events;
